<ul *ngIf="context && isDesktop" class="d-flex flex-column flex-lg-row">
  <li class="context-dropdown me-1 ml-1" *ngIf="organizationsToDisplay.length">
    <div>
      <ng-select [disabled]="isContextDisabled || (organizationsToDisplay.length < 2)" (change)="organizationChange()"
        [clearable]="false" placeholder="Firma" [(ngModel)]="context.organizationId" [searchable]="isSearchable()">
        <ng-option *ngFor="let firm of organizationsToDisplay" [value]="firm.id">
          <ng-container> {{ firm.nFirma }}</ng-container>
        </ng-option>
      </ng-select>
    </div>
  </li>

  <li class="context-dropdown me-1 ml-1 business-unit" *ngIf="businessUnits.length">
    <div>
      <ng-select [disabled]="isContextDisabled || (businessUnits.length < 2)" (change)="businessUnitChange()"
        [clearable]="false" placeholder="Poslovna jedinica" [(ngModel)]="context.businessUnit"
        [searchable]="isSearchable()">
        <ng-option *ngFor="let unit of businessUnits" [value]="unit.sifra">
          <ng-container> {{ unit.naziv }}</ng-container>
        </ng-option>
      </ng-select>
    </div>
  </li>

  <li class="context-dropdown me-1 ml-1 business-years" *ngIf="yearsToDisplay.length" style="max-width: 100px;">
    <div>
      <ng-select [disabled]="isContextDisabled || isContextYearDisabled || (yearsToDisplay.length < 2)"
        (change)="yearChange()" [clearable]="false" placeholder="Godina" [(ngModel)]="context.year"
        [searchable]="isSearchable()">
        <ng-option *ngFor="let year of yearsToDisplay" [value]="year.godina">
          {{ year.godina }}
        </ng-option>
      </ng-select>
    </div>
  </li>
</ul>


@if (context && isMobile) {
<div>
  <h6 class="f-18 mb-0 dropdown-title">{{ "PROPERTIES.Kontekst" | translate}}</h6>
  <ul>
    <li class="context-dropdown me-1 ml-1" *ngIf="organizationsToDisplay.length">
      <div>
        <ng-select [disabled]="isContextDisabled || (organizationsToDisplay.length < 2)" (change)="organizationChange()"
          [clearable]="false" placeholder="Firma" [(ngModel)]="context.organizationId" [searchable]="isSearchable()">
          <ng-option *ngFor="let firm of organizationsToDisplay" [value]="firm.id">
            <ng-container> {{ (firm.nFirma.length > 30)? (firm.nFirma | slice:0:30)+'...':(firm.nFirma)
              }}</ng-container>
          </ng-option>
        </ng-select>
      </div>
    </li>

    <li class="context-dropdown me-1 ml-1 business-unit" *ngIf="businessUnits.length">
      <div>
        <ng-select [disabled]="isContextDisabled || (businessUnits.length < 2)" (change)="businessUnitChange()"
          [clearable]="false" placeholder="Poslovna jedinica" [(ngModel)]="context.businessUnit"
          [searchable]="isSearchable()">
          <ng-option *ngFor="let unit of businessUnits" [value]="unit.sifra">
            <ng-container> {{ (unit?.naziv?.length > 20)? (unit?.naziv | slice:0:20)+'...': (unit?.naziv)
              }}</ng-container>
          </ng-option>
        </ng-select>
      </div>
    </li>

    <li class="context-dropdown me-1 ml-1 business-years" *ngIf="yearsToDisplay.length">
      <div>
        <ng-select [disabled]="isContextDisabled || isContextYearDisabled || (yearsToDisplay.length < 2)"
          (change)="yearChange()" [clearable]="false" placeholder="Godina" [(ngModel)]="context.year"
          [searchable]="isSearchable()">
          <ng-option *ngFor="let year of yearsToDisplay" [value]="year.godina">
            {{ year.godina }}
          </ng-option>
        </ng-select>
      </div>
    </li>
  </ul>
</div>
}